module.exports = "### 关于SMUI\n\n> SMUI是一套基于Vue开发的，适用于PC的组件库\n\n### 使用安装\n\n* NPM安装\n\n```bash\nnpm i smui # for vue1.x\n\nnpm i smui-next # for vue2.x\n```\n\n* CDN安装\n\nhttp://image.uc.cn/s/uae/g/2p/smui/product/smui-0.0.11.js\n\n\n### 快速框架搭建\n\nvue init sm-ui/webpack#v2\n\n### 链接\n\n[开发源码](http://gitlab.alibaba-inc.com/front_web/smui-dev.git)\n\n[组件库官网](https://sm-ui.github.io/)"


//////////////////
// WEBPACK FOOTER
// ../~/.0.5.1@raw-loader!./docs/README.md
// module id = 397
// module chunks = 1 4